import { Node, mergeAttributes } from "@tiptap/core";

export const YouTubeServerside = Node.create({
  name: "youtube",

  group: "block",
  content: "inline*",

  parseHTML() {
    return [
      {
        tag: 'a[data-type="youtube"]',
      },
    ];
  },
  addAttributes() {
    return {
      url: { default: null },
      "data-id": { default: null },
      class: { default: "inline-youtube" },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "youtube",
        class: `react-renderer node-youtube ${HTMLAttributes.class}`,
      }),
      0,
    ];
  },
});
